import { ReactElement, useState } from "react";
import { Dropdown, Icon, Item, Label, Segment } from "semantic-ui-react";
import ErrorsView from "./ErrorsView";
import { CalibrationCertificate } from "../models/CalibrationCertificate";
import CalibrationCertificateModal from "./CalibrationCertificateModal";
import moment from "moment";
import { PermitAssignment } from "../models/PermitAssignment";

interface Props {
  errors?: string[] | undefined;
  calibrationCertificate?: CalibrationCertificate | null;
  setCalibrationCertificate?: (calibrationCertificate: CalibrationCertificate) => void;
  permitTeam?: PermitAssignment[];
}

function PermitCalibrationCertificate({
  errors,
  calibrationCertificate,
  setCalibrationCertificate,
  permitTeam,
}: Props): ReactElement {
  const [openCalCertificateModal, setOpenCalCertificateModal] = useState(false);

  return (
    <>
      <Segment style={{ padding: "7px", margin: "0px", "box-shadow": "0px 0px", backgroundColor: "transparent" }}>
        <Label attached="top" style={{ padding: "0px", margin: "0px" }}>
          <Segment basic style={{ padding: "0px", margin: "0px" }}>
            <Label as="a" size="large" style={{ padding: "5px" }}>
              <Dropdown
                text="CAT and Genny"
                disabled={!setCalibrationCertificate}
                icon={setCalibrationCertificate ? undefined : null}
              >
                <Dropdown.Menu>
                  {permitTeam && permitTeam.length > 0 && <Dropdown.Header content="Select Team Member to Set" />}
                  {permitTeam &&
                    permitTeam.map((member) => (
                      <Dropdown.Item
                        key={member.orgRole.id}
                        disabled={
                          !member.orgUser?.calibrationCertificate?.catSerialNumber &&
                          !member.orgUser?.calibrationCertificate?.catCalibrationDate &&
                          !member.orgUser?.calibrationCertificate?.catCalibrationDueDate &&
                          !member.orgUser?.calibrationCertificate?.gennySerialNumber &&
                          !member.orgUser?.calibrationCertificate?.gennyCalibrationDate &&
                          !member.orgUser?.calibrationCertificate?.gennyCalibrationDueDate
                        }
                        onClick={() => {
                          setCalibrationCertificate?.({
                            catSerialNumber: member.orgUser?.calibrationCertificate?.catSerialNumber || "",
                            catCalibrationDate: member.orgUser?.calibrationCertificate?.catCalibrationDate || null,
                            catCalibrationDueDate:
                              member.orgUser?.calibrationCertificate?.catCalibrationDueDate || null,
                            gennySerialNumber: member.orgUser?.calibrationCertificate?.gennySerialNumber || "",
                            gennyCalibrationDate: member.orgUser?.calibrationCertificate?.gennyCalibrationDate || null,
                            gennyCalibrationDueDate:
                              member.orgUser?.calibrationCertificate?.gennyCalibrationDueDate || null,
                          });
                        }}
                      >
                        {member.orgUser?.user.displayName}
                      </Dropdown.Item>
                    ))}
                  <Dropdown.Item
                    onClick={(e) => {
                      setOpenCalCertificateModal(true);
                    }}
                  >
                    <Icon name="edit outline" />
                    Set manually
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </Label>
          </Segment>
        </Label>
        <Item.Group>
          <>
            {/* Show the calibration certificate details if available */}
            {(calibrationCertificate?.catSerialNumber ||
              calibrationCertificate?.catCalibrationDate ||
              calibrationCertificate?.catCalibrationDueDate) && (
              <Item>
                <Item.Meta style={{ margin: "0px" }}>
                  <div style={{ marginBottom: "5px" }}>
                    CAT
                    {calibrationCertificate.catSerialNumber && " (" + calibrationCertificate.catSerialNumber + ")"}
                  </div>
                  {calibrationCertificate.catCalibrationDate
                    ? moment.utc(calibrationCertificate.catCalibrationDate).local().format("L")
                    : ""}
                  {calibrationCertificate.catCalibrationDueDate
                    ? " due " + moment.utc(calibrationCertificate.catCalibrationDueDate).local().format("L")
                    : ""}
                </Item.Meta>
              </Item>
            )}
            {(calibrationCertificate?.gennySerialNumber ||
              calibrationCertificate?.gennyCalibrationDate ||
              calibrationCertificate?.gennyCalibrationDueDate) && (
              <Item>
                <Item.Meta style={{ margin: "0px" }}>
                  <div style={{ marginBottom: "5px" }}>
                    Genny
                    {calibrationCertificate.gennySerialNumber && " (" + calibrationCertificate.gennySerialNumber + ")"}
                  </div>
                  {calibrationCertificate.gennyCalibrationDate
                    ? moment.utc(calibrationCertificate.gennyCalibrationDate).local().format("L")
                    : ""}
                  {calibrationCertificate.gennyCalibrationDueDate
                    ? " due " + moment.utc(calibrationCertificate.gennyCalibrationDueDate).local().format("L")
                    : ""}
                </Item.Meta>
              </Item>
            )}

            {/* If no calibration certificate is set, show a message */}
            {!calibrationCertificate?.catSerialNumber &&
              !calibrationCertificate?.catCalibrationDate &&
              !calibrationCertificate?.catCalibrationDueDate &&
              !calibrationCertificate?.gennySerialNumber &&
              !calibrationCertificate?.gennyCalibrationDate &&
              !calibrationCertificate?.gennyCalibrationDueDate && (
                <Item>
                  <Item.Meta style={{ margin: "0px" }}>Not set.</Item.Meta>
                </Item>
              )}
          </>
        </Item.Group>

        <ErrorsView errors={errors} />
      </Segment>

      {setCalibrationCertificate && (
        <CalibrationCertificateModal
          open={openCalCertificateModal}
          onClose={() => setOpenCalCertificateModal(false)}
          onSubmit={setCalibrationCertificate}
          calibrationCertificate={calibrationCertificate}
        ></CalibrationCertificateModal>
      )}
    </>
  );
}

export default PermitCalibrationCertificate;
